import { MSCalendar } from "../..";
import styles from "../styles.css";
import { IWeeklyState } from "@lib/store/src/calendar";
import { WeekModal } from "./week";
import { FwCheckboxElement } from "./week.types";
import { getNewTemplate } from "./add-week.templates";
import { getSelectedWeekDays } from "../modal.helpers";

/**
 * Добавление недельного расписания (расширение WeekModal class)
 * @class AddWeekModal
 * @extends WeekModal
 * @classdesc AddWeekModal
 * */
export class AddWeekModal extends WeekModal {
  weekDays: NodeListOf<FwCheckboxElement>; // Чекбоксы дней недели
  submitButton: HTMLButtonElement;

  constructor(rootID: string, root: MSCalendar) {
    super(rootID, root);
    super.init(getNewTemplate(), styles);
    this.initVars();
    this.listenDaysChange();

    this.validateForm = () => {
      const selectedWeekDays = getSelectedWeekDays(this.weekDays);
      this.isValidForm(selectedWeekDays);
    }
  }

  initVars() {
    const modal = this.popup.modalComponent;

    this.bodyEvents = modal.querySelector("#events");
    this.weekDays = modal.querySelectorAll(".week-days-container fw-checkbox");
    this.submitButton = modal.querySelector("#submit");
  }

  /**
   * Сброс формы до начальных значений
   */
  resetForm() {
    super.resetForm();

    // Сбрасываем выбранные дни недели
    this.weekDays.forEach((element) => {
      element.checked = false;
    });

    // Выбор текущего дня в чекбоксах
    this.updateCurrentWeekDay();
  }

  /**
   * Инициализация обработчиков событий
   */
  onStartup() {
    const modal = this.popup.modalComponent;

    modal.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;

      // Обработка кнопки "Добавить"
      if (target.closest("#submit")) {
        this.submit();
      }

      // Обработка кнопки "Сбросить"
      if (target.closest("#reset")) {
        this.close();
      }

      // Обработка кнопки "Добавить событие"
      if (target.closest("#add-event")) {
        this.addEventTime();
      }
    });

    this.bodyEvents?.addEventListener("click", (e) => this.onClickEvent(e));
  }

  listenDaysChange() {
    this.weekDays.forEach(weekday => {
      weekday.addEventListener('fwChange', () => {
        this.validateForm();
      })
    })
  }

  /**
   * Обработчик кнопки сохранения нового расписания
   * */
  submit() {
    const selectedWeekDays = getSelectedWeekDays(this.weekDays);
    if (!this.isValidForm(selectedWeekDays)) return;

    this.updateWeeklySchedule(selectedWeekDays); 

    this.close();
  }

  /**
   * Обновление расписания на выбранные дни
   */
  updateWeeklySchedule(selectedWeekDays: number[]) {
    const newWeeklySchedule: IWeeklyState = JSON.parse(
      JSON.stringify(this.root.store.weeklySchedule)
    );

    if (this.eventsState.length > 0) {
      selectedWeekDays.forEach((day) => {
        if (newWeeklySchedule[day]) {
          newWeeklySchedule[day].push(...this.eventsState);
        } else {
          newWeeklySchedule[day] = [...this.eventsState];
        }
      });

      this.store.onChange("weeklySchedule", newWeeklySchedule);

      this.root.saveSchedule();
    }
  }

  /**
   * Установка выбранного дня по умолчанию в календаре в чекбокс
   */
  private updateCurrentWeekDay() {
    const day = this.root.store.date.day(); // 0 (вс) - 6 (сб)
    const correctIndex = (day + 6) % 7; // Сдвигаем индекс, чтобы 0 был понедельником

    this.weekDays.forEach((el, i) => {
      el.checked = i === correctIndex;
    });
  }

  /**
   * Переключение видимости модального окна
   */
  toggle() {
    this.popup.modalComponent.toggle();
    if (!this.popup.modalComponent.active) return;
  }

  /**
   * Открытие модального окна
   */
  open() {
    this.popup.modalComponent.open();

    this.resetForm(); // Сброс формы
    this.popup.uiModal.resetSize();
    this.validateForm();
  }

  /**
   * Закрытие модального окна
   */
  close() {
    this.popup.modalComponent.close();
  }
}
